import { orderXClient } from '@/service/client'
import {
  AccountSettings,
  ServerMessage,
  SetLeverageRequest,
  SetLeverageResponse,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

/** Stored per-account settings. A venue with none answers an empty map and no default. */
export async function getAccountSettings(accountId: string): Promise<AccountSettings> {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      getAccountSettings: { accountId },
    })
    if (data.error) return Promise.reject(data.error)
    if (!data.accountSettings) {
      return Promise.reject(new Error('Account settings response was empty'))
    }
    return data.accountSettings
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function setLeverage(req: SetLeverageRequest): Promise<SetLeverageResponse> {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { setLeverage: req })
    if (data.error) return Promise.reject(data.error)
    return data.setLeverageResponse as SetLeverageResponse
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}
